module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }